import { ConferenciaDeBaiaRepository } from "../../../repositories/v2/ConferenciaDeBaiaRepository";

export class ConferenciaDeBaiaService {
  vm;
  status;
  loading = false;

  ConferenciaDeBaiaRepository;

  constructor(ConferenciaDeBaiaRepository) {
    this.conferenciaDeBaiaRepository = ConferenciaDeBaiaRepository;
  }

  static build() {
    const conferenciaDeBaiaRepository = ConferenciaDeBaiaRepository.build();
    return new ConferenciaDeBaiaService(conferenciaDeBaiaRepository);
  }

  setVm(vm) {
    this.vm = vm;
    return this;
  }

  async setSearch(volume) {
    this.loading = true;
    if (!this.isVolumeValid(volume)) {
      this.vm.modalAlert.message = "Volume não pertence à linha de painéis!";
      this.vm.modalAlert.variant = "danger";
      this.vm.$bvModal.show("modal-error");
      this.vm.conditionMessage = false;
      this.loading = false;
      return;
    }
    try {
      const response =
        await this.conferenciaDeBaiaRepository.getPedidoPerVolume(volume);
      if (response.data.statusCode === 200) {
        this.vm.conditionMessage = true;
        this.vm.volumeData = response.data.data;
        this.loading = false;
      } else {
        this.vm.modalAlert.message =
          response.data.message ?? "Erro ao bipar volume";
        this.vm.modalAlert.variant = "danger";
        this.vm.$bvModal.show("modal-error");
        this.vm.conditionMessage = false;
        throw response;
      }
    } catch (error) {
      console.log(error);
    }
  }

  isVolumeValid(volume) {
    const ultimoQuatroDigitos = volume.slice(-4);
    const primeiroDígito = ultimoQuatroDigitos.charAt(0);
    return primeiroDígito === "1";
  }

  async confirmVolume(volume) {
    this.loading = true;
    try {
      const response =
        await this.ConfereicaDeBaiaRepository.postConfirmErrorPedido(volume);
      if (response.data.statusCode === 200) {
        this.vm.modalAlert.message = response.data.message;
        this.vm.modalAlert.variant = "success";
        this.vm.$bvModal.show("modal-error");
        this.vm.volumeData = [];
        this.loading = false;
      } else {
        this.vm.modalAlert.message = response.data.message;
        this.vm.modalAlert.variant = "danger";
        this.vm.$bvModal.show("modal-error");

        this.loading = false;
      }
    } catch (error) {
      console.log(error);
    }
  }
}
